/* eslint-disable react/no-unknown-property,jsx-a11y/iframe-has-title */

'use client'

import { isMobile } from 'react-device-detect'
import { useIsAppControl } from '@store/isApp'
import { Box } from '@mui/joy'
import { pxToRem } from '@ui/style/muiTheme'
import useIframeZoom from '@hooks/useIframeZoom'
import { theme } from '@ui/style'

/** 아티클(기사) 상단 텍스트 광고 */
const TextTopAd = () => {
	const { iframeStyles } = useIframeZoom()
	const { isApp } = useIsAppControl()
	const isMobileWeb = isMobile && !isApp

	if (isApp) {
		return null
	}

	return (
		<Box
			className="print-hide"
			sx={{
				width: '100%',
				marginTop: `${pxToRem(48)} !important`,
				[theme.mediaQueries.under.origin]: {
					height: pxToRem(110),
					overflow: 'hidden',
					'&>iframe': iframeStyles,
				},
				'&>iframe': {
					marginBottom: '0px !important',
				},
			}}
		>
			<iframe
				width="100%"
				height="110"
				src={`//ad.reople.co.kr/cgi-bin/PelicanC.dll?impr?pageid=${
					isMobileWeb ? '0HEd' : '0HEf'
				}&out=iframe`}
				allowTransparency
				marginWidth={0}
				marginHeight={0}
				frameBorder="0"
				scrolling="no"
				sandbox="allow-same-origin allow-scripts allow-forms allow-top-navigation allow-popups allow-modals allow-top-navigation-by-user-activation allow-popups-to-escape-sandbox"
			/>
		</Box>
	)
}

export default TextTopAd
